import { Row } from '@tanstack/react-table';
import {
  DisplayPreArrivalFormField,
  PreArrivalFormFields,
} from 'pages/automations/preArrivalForm/PreArrivalFormTab.types';
import { useTranslation } from 'react-i18next';

const DisplayNameCell = ({ row }: { row: Row<DisplayPreArrivalFormField> }) => {
  const { id, name } = row.original;

  const { t } = useTranslation();

  const isCustomField = id === PreArrivalFormFields.CUSTOM;

  if (isCustomField) {
    return <div>{name}</div>;
  }

  return (
    <div>
      {t(
        `pageAutomations.preArrivalForm.informationTable.fields.${id}.displayName`,
      )}
    </div>
  );
};

export default DisplayNameCell;
